import { render } from "./Admin.Finance.CreditReceiptsDatatable.vue?vue&type=template&id=73cdbc8b"
import script from "./Admin.Finance.CreditReceiptsDatatable.vue?vue&type=script&lang=js"
export * from "./Admin.Finance.CreditReceiptsDatatable.vue?vue&type=script&lang=js"

import "./Admin.Finance.CreditReceiptsDatatable.vue?vue&type=style&index=0&id=73cdbc8b&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__